// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3TpXf","right":"styles_right__1G6lW"};